import Grid from '@material-ui/core/Grid'

import { H2 } from '../../Typography'

const SubPageContent = ({ children, fullWidth, heading, modal, customCol, customMargin, customPadding, ...rest }) => (
  <Grid container>
    <Grid
      item
      xs={12}
      md={fullWidth ? 12 : customCol}
      style={{
        margin: customMargin,
        padding: customPadding,
      }}
      {...rest}
    >
      {heading && (
        <H2 marginBottom fontWeight={modal && 'light'}>
          {heading}
        </H2>
      )}
      {children}
    </Grid>
  </Grid>
)

SubPageContent.defaultProps = {
  customCol: 8,
}

export default SubPageContent
